// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardContentItem_wrapper__Nj1ST","label":"CardContentItem_label__aiKYR","value":"CardContentItem_value__nfOmD"};